export function detectTenant(): string {
  const envTenant = import.meta.env.VITE_MJSB2B_TENANT
  if (envTenant) return envTenant

  const host = window.location.hostname
  if (host.includes('localhost')) {
    const params = new URLSearchParams(window.location.search)
    return params.get('tenant') || 'mudjai'
  }

  return host.split('.')[0] as string // production subdomain fallback
}
